<template>
    <div class="mx-auto">
        <p class="mb-2"><b>Informe o Devedor:</b>
            <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
               v-b-modal.modal-info-devedor
               v-b-popover.hover.top="'Clique para Detalhes'"></i>
        </p>

        <b-row v-if="devedores == null">
            <b-col md="2">
                <b-form-group
                        label="Número do CPF / CNPJ:"
                        label-for="cpf"
                        class="text-label"
                        :description="validations.cpf.valid ? 'Somente os números' : ''">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            :disabled="requisicao.cnj != null && requisicao.cnj != ''"
                            v-model="requisicao.devedor.documento"
                            v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                            @change="buscarDevedor();"
                            @keydown.tab.prevent="validarTabDevedor();"
                            :class="'cpfCnpj ' + (!validations.cpf.valid ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-if="!validations.cpf.valid && validations.cpf.invalidDocument" class="invalid-message">Documento inválido!</span>
                    <span v-if="!validations.cpf.valid && validations.cpf.semCarta" class="invalid-message">Não consta(m) dívida(s) ativa(s) ajuizada(s) inscritas pela SEFA para o Devedor informado registrada(s) no PROAJU!</span>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label">
                    <b-form-input
                            v-if="requisicao.devedor.codContribuinte != null"
                            type="text"
                            id="devedor"
                            v-model="requisicao.devedor.nome"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                    <b-form-input
                            v-if="requisicao.devedor.codContribuinte == null"
                            type="text"
                            id="devedor"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        tabindex="-1"
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        :disabled="!validations.cpf.valid || (requisicao.devedor.documento == null || requisicao.devedor.documento == '')"
                        @click="abrirModalDevedor(requisicao.devedor, false)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
                <b-button
                        tabindex="-1"
                        class="icon-button btn-documentos"
                        title="Documentação do Devedor"
                        variant="outline-primary"
                        :disabled="requisicao.devedor.documento == null 
                                   || requisicao.devedor.documento == ''
                                   || requisicao.devedor.documento.length < 14
                                   || (requisicao.devedor.documento.length == 14 && !validations.cpf.valid) 
                                   || (requisicao.devedor.documento.length == 18 && !this.validarCnpjAlfanumerico(requisicao.devedor.documento))"
                        @click="abrirModalDocumentosDevedor()">
                    <i class="far fa-copy fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-for="devedorLista in devedores">
            <b-col md="2">
                <b-form-group
                        label="Número do CPF / CNPJ:"
                        label-for="cpf"
                        class="text-label">
                    <b-input-group>
                        <b-input-group-append>
                            <b-form-radio name="radioDevedor" v-model="radioDevedor" :value="devedorLista.documento" @change="atribuirDevedorRadio(devedorLista)"></b-form-radio>
                        </b-input-group-append>
                        <b-form-input
                                :class="devedorLista.documento == radioDevedor ? 'text-bold' : ''"
                                type="text"
                                id="num-documento"
                                data-vv-as="CPF"
                                :disabled="true"
                                v-model="devedorLista.documento"
                                v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label">
                    <b-form-input
                            :class="devedorLista.documento == radioDevedor ? 'text-bold' : ''"
                            v-if="devedorLista.codContribuinte != null"
                            type="text"
                            id="devedor"
                            v-model="devedorLista.nome"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                    <b-form-input
                            v-if="devedorLista.codContribuinte == null"
                            type="text"
                            id="devedor"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        tabindex="-1"
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        :disabled="radioDevedor != devedorLista.documento"
                        @click="abrirModalDevedor(devedorLista, true)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr>

        <p class="mb-2"><b>Informe o número do processo (CNJ):</b>
            <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
               tabindex="-1"
               v-b-modal.modal-info-cnj
               v-b-popover.hover.top="'Clique para Detalhes'"></i>
        </p>
        <b-row>
            <b-col md="2">
                <b-form-group
                        :description="validations.cnj.valid ? 'Somente os números' : ''">
                    <b-form-input
                            ref="cnj"
                            type="text"
                            id="num-documento"
                            v-model="requisicao.cnj"
                            v-mask="['#######-##.####.#.##.####']"
                            @change="buscarCnj();"
                            @focus="changeFocus();"
                            :class="'cnj ' + (!validations.cnj.valid ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-if="!validations.cnj.valid" class="invalid-message">Número CNJ inválido!</span>
                </b-form-group>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-info-devedor"
                id="modal-info-devedor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Gerar Requisição a partir de um CPF/CNPJ"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Exibirá todas as CDAs ajuizadas do devedor informado pelo CPF, CNPJ ou CNPJ raiz (dossiê do devedor), registradas na base do sistema PROAJU.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-devedor')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-cnj"
                id="modal-info-cnj"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Gerar Requisição para uma execução fiscal"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Exibirá apenas a(s) CDA(s) vinculada(s) à execução fiscal informada e registrada na base do sistema PROAJU.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-cnj')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-inexistente"
                id="modal-info-inexistente"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Processo não cadastrado no PROAJU"
                header-bg-variant="info"
                header-text-variant="white"
                @hide="fecharAlertaCnj()"
                @close="fecharAlertaCnj()">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>O número CNJ informado não consta na base do PROAJU!</p>
                        </li>
                        <li>
                            <p>Tratando-se de uma execução fiscal de dívida ativa inscrita pela SEFA, solicite ao NII o cadastro da execução fiscal em questão no sistema PROAJU.</p>
                        </li>
                        <li>
                            <p>Para gerar requisição de honorários provenientes de processo que não seja execução fiscal ou de execução fiscal de D.A. não inscrita pela SEFA, utilize o fluxo “3) Honorários de Ação Judicial”.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="fecharAlertaCnj()"> Voltar</b-button>
            </template>
        </b-modal>

        <CompLoading ref="loadingDevedor"/>
        <ModalIncluirDevedor ref="modalDevedor"
                             @novoDevedor="salvarDevedor"
                             @cancelarNovoDevedor="mudarFocusCpf" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loadingDevedor"
                @salvarDevedor="salvarDevedor"/>

	    <ModalDocumentosDevedor ref="modalDocumentosDevedor"
	                            :loading="$refs.loadingDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import CompLoading from "../../shared/components/CompLoading";
    import ModalDocumentosDevedor from "../../shared/components/ModalDocumentosDevedor";

    export default {
        props: ['requisicao'],
        mixins: [ formatarMixins ],
        components: {ModalDocumentosDevedor, ModalIncluirDevedor, ModalAlterarDevedor, CompLoading},
        data() {
            return {
                urlApi: null,
                devedores: null,
                devedorAtual: null,
                radioDevedor: null,
                validations: {
                    cpf: {
                        valid: true,
                        invalidDocument: false,
                        semCarta: false
                    },
                    cnj: {
                        valid: true,
                        carta: false
                    }
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            async buscarDevedor() {
                this.validations.cpf.valid = true;
                this.validations.cpf.invalidDocument = false;
                this.validations.cpf.semCarta = false;
                if(this.requisicao.devedor.documento == null || this.requisicao.devedor.documento == "") {
                    this.atribuirDevedor(null);
                    return;
                }

                if(this.requisicao.devedor.documento.length < 10 || (this.requisicao.devedor.documento.length > 10 && this.requisicao.devedor.documento.length <= 14 && !this.validarCpf(this.requisicao.devedor.documento))
                    || (this.requisicao.devedor.documento.length > 14 && !this.validarCnpjAlfanumerico(this.requisicao.devedor.documento))) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.invalidDocument = true;
                    this.requisicao.devedor.nome = "";
                    this.mudarFocusCpf();
                    return;
                }

                let devedor = {
                    documento: this.requisicao.devedor.documento
                };

                this.$refs.loadingDevedor.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(this.verificarValorVazio(this.requisicao.devedor.documento)) {
                        return;
                    }
                    if(response.data != null && response.data != "") {
                        let devedorRetorno = response.data;
                        devedorRetorno.documento = this.requisicao.devedor.documento;
                        this.atribuirDevedor(devedorRetorno);

                        setTimeout(()=>{
                            if(this.requisicao.devedor.codContribuinte == null) {
                                this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.requisicao.devedor);
                            }
                        }, 200);
                    } else {
                        this.requisicao.devedor.nome = null;
                        this.validations.cpf.valid = false;
                        this.validations.cpf.semCarta = true;
                    }
                }).finally(() => {
                    this.$refs.loadingDevedor.hideLoading();
                })
            },
            validarTabDevedor() {
                if(this.requisicao.devedor.documento == null || this.requisicao.devedor.documento == "") {
                    document.getElementsByClassName('cnj')[0].focus();
                } else {
                    this.buscarDevedor();
                }
            },
            changeFocus() {
                if(this.requisicao.cnj == "" || this.requisicao.cnj == null) {
                    this.atribuirDevedor(null);
                    this.validations.cpf.valid = true;
                    this.validations.cpf.invalidDocument = false;
                    this.validations.cpf.semCarta = false;
                }
            },
            async buscarCnj() {
                this.$store.commit("setMessages", {});

                this.atribuirDevedor(null);
                this.devedorAtual = null;
                this.radioDevedor = null;
                this.validations.cnj.valid = true;
                if(this.requisicao.cnj == "" || this.requisicao.cnj == null) {
                    this.devedores = null;
                    return;
                }

                if (this.requisicao.cnj != '' && this.onlyNumber(this.requisicao.cnj).length < 20) {
                    this.requisicao.cnj = this.mascaraCnj(this.onlyNumber(this.requisicao.cnj).padStart(20, '0'));
                }

                if(!this.validaCnj(this.requisicao.cnj)) {
                    this.validations.cnj.valid = false;
                    this.mudarFocusCnj();
                    return;
                }

                this.$refs.loadingDevedor.showLoading();
                axios.get(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/obterContribuintes/${this.requisicao.cnj}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.devedores = null;
                    if(response.data == null || response.data.length <= 0) {
                        this.devedores = null;
                        this.showModal('modal-info-inexistente');
                    } else {
                        if(response.data.length == 1) {
                            this.atribuirDevedor(response.data[0]);
                        } else {
                            this.devedores = response.data;
                        }
                    }
                }).catch((error) => {
                    if (error.response !== undefined && error.response.status === 404) {
                        this.validations.cnj.valid = false;
                        this.devedores = null;
                        this.showModal('modal-info-inexistente');
                    } else {
                        this.exibirErro(error);
                    }
                }).finally(() => {
                    this.$refs.loadingDevedor.hideLoading();
                })
            },
            abrirModalDevedor(devedor, devedorLista) {
                if(devedorLista) {
                    this.devedorAtual = devedor;
                } else {
                    this.devedorAtual = null;
                }

                if(devedor.codContribuinte != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(devedor.codContribuinte);
                } else {
                    this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(devedor);
                }
            },
            salvarDevedor(contribuinte) {
                if(this.devedorAtual != null) {
                    let listaDevedores = [];
                    for(let i = 0; i < this.devedores.length; i++) {
                        if(this.devedores[i].documento == contribuinte.documento) {
                            listaDevedores.push(contribuinte);
                        } else {
                            listaDevedores.push(this.devedores[i]);
                        }
                    }
                    this.devedores = listaDevedores;
                }
                this.atribuirDevedor(contribuinte);
            },
            atribuirDevedor(contribuinte) {
                this.$emit('atribuirDevedor', contribuinte);

                if(contribuinte != null && contribuinte.codContribuinte == null) {
                    setTimeout(()=>{
                        if(this.requisicao.devedor.codContribuinte == null) {
                            this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.requisicao.devedor);
                        }
                    }, 200);
                }
            },
            atribuirDevedorRadio(contribuinte) {
                this.$emit('atribuirDevedor', contribuinte);

                if(contribuinte.codContribuinte == null) {
                    this.abrirModalDevedor(contribuinte, true);
                }
            },
            validarForm() {
                return this.validations.cpf.valid && this.validations.cnj.valid
                    && this.requisicao.devedor.codContribuinte != null
                    && !this.$refs.modalDevedor.isShow()
                    && !this.$refs.modalAlterarDevedor.isShow()
                    && !this.$refs.modalDocumentosDevedor.isShow();
            },
            modalOpen() {
                return this.$refs.modalDevedor.isShow() || this.$refs.modalAlterarDevedor.isShow() || this.$refs.modalDocumentosDevedor.isShow();
            },
            mudarFocusCpf() {
                document.getElementsByClassName('cpfCnpj')[0].focus();
            },
            mudarFocusCnj() {
                document.getElementsByClassName('cnj')[0].focus();
            },

            fecharAlertaCnj() {
                this.requisicao.cnj = '';
                this.hideModal('modal-info-inexistente');
                this.mudarFocusCnj();
            },

	        abrirModalDocumentosDevedor () {
		        document.activeElement.blur();
		        this.$refs['modalDocumentosDevedor'].abrirModal(this.requisicao.devedor.documento, this.requisicao.devedor.codContribuinte);
	        },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
        }
    }
</script>

<style scoped>
    .icon-button {
        font-size: 1.5rem;
        margin-left: 1rem;
        padding: 0 0.5rem;
    }

    .vertical-middle {
        vertical-align: middle;
    }
</style>
